const widthCalc = (items) => `${Math.round(100 / (items - 1))}%`;

export default widthCalc;
